export default "<div id=\"sky\"></div>\n<div id=\"night\" [@daytime]=\"daytime\"><div></div></div>\n";